import CircularProgress from "@material-ui/core/CircularProgress";
import React from "react";
import {ModalStyles} from "./CubbyModalStyles";

export const CubbyModalLoadingPanel = () => {
    const style = ModalStyles();

    return (
        <div className={style.container}>
            <div className={style.body}>
                <CircularProgress/>
            </div>
        </div>
    );
};